// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"181581bc36dc3eb1fd92","966":"820bb5971fa19d046407"}[chunkId] + ".js";
};